"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Sarah L.",
  quote: "The guidance I received during my father's transition was a beacon of light in a difficult time. I felt truly seen and supported.",
  position: "Houston, TX"
}, {
  author: "Robert M.",
  quote: "Navigating complex healthcare systems felt impossible until I found this team. Their navigation support is simply life-changing.",
  position: "Austin, TX"
}, {
  author: "Elena G.",
  quote: "Professional, compassionate, and deeply knowledgeable. They didn't just provide services; they provided absolute peace of mind for our family.",
  position: "Dallas, TX"
}];
export default function ClientTestimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="92351" id="patient-testimonials" className="dark bg-background text-foreground py-24 md:py-32 overflow-hidden relative backdrop-blur-sm">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent opacity-50"></div>

      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex flex-col items-center text-center mb-16 md:mb-24">
          <span className="text-secondary font-sans text-sm font-bold tracking-[0.2em] uppercase mb-4 block">
            Stories of Care
          </span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground">
            Patient Testimonials
          </h2>
          <div className="w-24 h-[2px] bg-secondary mt-8"></div>
        </div>

        <div className="max-w-6xl mx-auto relative">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-6">
              {testimonials.map((item, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/2">
                  <div className="flex flex-col justify-between h-full p-8 md:p-12 bg-card/40 border border-border/20 relative group hover:border-primary/40 transition-colors duration-500 rounded-xl shadow-xl">
                    <Quote className="absolute top-8 right-8 w-16 h-16 text-secondary/10 rotate-180 transition-transform duration-700 group-hover:scale-110 group-hover:text-secondary/20" />
                    
                    <div className="relative z-10 mb-10">
                      <p className="font-serif text-2xl md:text-3xl leading-relaxed text-card-foreground italic">
                        "{item.quote}"
                      </p>
                    </div>
                    
                    <div className="relative z-10 mt-auto pt-8 border-t border-border/20">
                      <h4 className="font-sans font-bold text-card-foreground uppercase tracking-wider text-sm md:text-base">
                        {item.author}
                      </h4>
                      <p className="font-sans text-sm text-secondary mt-1 tracking-wide">
                        {item.position}
                      </p>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="flex items-center justify-center gap-4 mt-12 md:mt-16">
              <CarouselPrevious className="static translate-y-0 translate-x-0 size-12 border-border/30 hover:border-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 rounded-full" />
              <CarouselNext className="static translate-y-0 translate-x-0 size-12 border-border/30 hover:border-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 rounded-full" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}